import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updatePackageSaga } from "src/store/web-packages/saga";
import { PackageDetailDto } from "src/store/web-packages/type";
import * as Yup from "yup";
import { CurrencyDto } from "src/store/system/type";
import { getCurrencies } from "src/store/system/saga";
import PackageDrawer from "./PackageDrawer";

const PackageEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: PackageDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currencies, setCurrencies] = useState<CurrencyDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getCurrencies({
          payload: {
            onSuccess: (m, p) => setCurrencies(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);

  return (
    <PackageDrawer
      open={open}
      onHide={onHide}
      title={t("Package.EditFormTitle").toString()}
      currencies={currencies}
      initialValues={{
        Id: data.Id,
        Name: data.Name,
        Translates: data.Translates,
        AssetFeatureCount: data.AssetFeatureCount,
        AssetLimit: data.AssetLimit,
        UserLimit: data.UserLimit,
        MailboxLimit: data.MailboxLimit,
        StorageLimit: data.StorageLimit,
        Location: data.Location,
        Management: data.Management,
        MobileApp: data.MobileApp,
        WebSite: data.WebSite,
        APIIO: data.APIIO,
        ListPriceMonthly: data.ListPriceMonthly,
        CampaignPriceMonthly: data.CampaignPriceMonthly,
        ListPriceYearly: data.ListPriceYearly,
        CampaignPriceYearly: data.CampaignPriceYearly,
        CampaignEndDate: data.CampaignEndDate,
        UygunaKirala: data.UygunaKirala,
        Booqapp: data.Booqapp,
        Freemium: data.Freemium,
        CurrencyId: data.CurrencyId,
        ShowWeb: data.ShowWeb,
        Order: data.Order,
        ParentId: data.ParentId ?? "",
        Maintenance: data.Maintenance,
        FinancialAccounts: data.FinancialAccounts,
        ExtraServices: data.ExtraServices,
        Expenses: data.Expenses,
        Insurances: data.Insurances,
        Suppliers: data.Suppliers,
      }}
      validationSchema={Yup.object().shape({
        Translates: Yup.array(
          Yup.object({
            Name: Yup.string().required(t("Validation.Required").toString()),
          })
        ),
        CurrencyId: Yup.number().required(t("Validation.Required").toString()),
        AssetLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        UserLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        MailboxLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        StorageLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        Location: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        CampaignPriceMonthly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        ListPriceMonthly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        CampaignPriceYearly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        ListPriceYearly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        CampaignEndDate: Yup.string()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
      })}
      onSubmit={(values) => {
        dispatch(
          updatePackageSaga({
            payload: {
              onSuccess: (message, payload) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => {
                toast.error(message, { theme: "colored" });
              },
            },
            id: data.Id,
            body: values,
          })
        );
      }}
    />
  );
};
export default PackageEditForm;
